import { Link, useNavigate } from "react-router-dom";
import { Trash2, ArrowRight, ShoppingBag } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function CartPage() {
  const { items, removeItem, total } = useCart();
  const navigate = useNavigate();

  if (items.length === 0)
    return (
      <div data-testid="cart-page" className="mx-auto max-w-3xl px-5 py-24 text-center md:px-8">
        <ShoppingBag className="mx-auto h-12 w-12 text-obsidian/30" />
        <h1 className="mt-6 font-serif text-4xl font-light tracking-tighter text-obsidian">Your cart is empty</h1>
        <p className="mt-3 text-obsidian/60">Discover premium digital goods built to help you launch.</p>
        <Link
          to="/"
          data-testid="cart-browse-btn"
          className="mt-8 inline-flex items-center gap-2 rounded-full bg-signal px-7 py-3.5 text-sm font-semibold uppercase tracking-[0.15em] text-white transition-colors hover:bg-red-700"
        >
          Browse the shop <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    );

  return (
    <div data-testid="cart-page" className="mx-auto max-w-6xl px-5 py-12 md:px-8">
      <h1 className="font-serif text-4xl font-light tracking-tighter text-obsidian md:text-5xl">Your cart</h1>

      <div className="mt-10 grid gap-10 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <div className="border border-obsidian/15 bg-white">
            {items.map((item) => (
              <div
                key={item.product_id}
                data-testid={`cart-item-${item.product_id}`}
                className="flex items-center gap-4 border-b border-obsidian/10 p-4 last:border-b-0"
              >
                <div className="h-20 w-24 shrink-0 overflow-hidden border border-obsidian/10">
                  <img src={item.image} alt={item.title} className="h-full w-full object-cover" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-serif text-lg tracking-tight text-obsidian">{item.title}</h3>
                  <p className="text-xs uppercase tracking-[0.15em] text-obsidian/40">Qty {item.quantity}</p>
                </div>
                <div className="font-serif text-xl tracking-tighter text-obsidian">
                  ${(item.price * item.quantity).toFixed(2)}
                </div>
                <button
                  data-testid={`remove-item-${item.product_id}`}
                  onClick={() => removeItem(item.product_id)}
                  className="text-obsidian/40 transition-colors hover:text-signal"
                >
                  <Trash2 className="h-5 w-5" />
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          <div className="border border-obsidian/15 bg-white p-6">
            <h2 className="text-xs font-semibold uppercase tracking-[0.2em] text-obsidian/50">Summary</h2>
            <div className="mt-5 space-y-3 border-b border-obsidian/10 pb-5 text-sm text-obsidian/70">
              <div className="flex justify-between"><span>Subtotal</span><span>${total.toFixed(2)}</span></div>
              <div className="flex justify-between"><span>Taxes</span><span>$0.00</span></div>
            </div>
            <div className="mt-5 flex items-end justify-between">
              <span className="text-xs uppercase tracking-[0.15em] text-obsidian/50">Total</span>
              <span data-testid="cart-total" className="font-serif text-3xl tracking-tighter text-obsidian">${total.toFixed(2)}</span>
            </div>
            <button
              data-testid="checkout-btn"
              onClick={() => navigate("/checkout")}
              className="mt-6 w-full bg-signal py-4 text-sm font-semibold uppercase tracking-[0.2em] text-white transition-colors hover:bg-red-700"
            >
              Checkout
            </button>
            <Link to="/" className="mt-3 block text-center text-xs uppercase tracking-[0.15em] text-obsidian/50 hover:text-signal">
              Continue shopping
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
